<section *ngIf="subasta && !subasta.activo"
    class="text-center padding-30px-tb xs-padding-60px-tb blog-style1 bg-light-deep-yellow  border-none header-margin-top-medium">
    <div class="container-fluid">
        <h2 class="title alt-font title-extra-large font-weight-700 text-dark-brown margin-one-bottom">Lote Inactivo
        </h2>
    </div>
</section>
<section *ngIf="subasta && subasta.activo"
    class="padding-30px-tb xs-padding-60px-tb blog-style1 bg-light-deep-yellow  border-none header-margin-top-medium"
    id="">
    <div class="container">
        <!-- title -->
        <div class="row text-detail">
            <div class="col-md-4 margin-five-bottom">
                <!-- title -->
                <h2 class="title alt-font title-extra-large font-weight-700 text-dark-brown margin-one-bottom">Lote
                    {{subasta.numero}} <small> - ID {{ subasta.identificador }} <br class="visible-xs-block">
                        <span class="hidden-xs">-</span> Fecha
                        {{ subasta.fechaInspeccion | date: 'dd/MM/yyyy' }}</small></h2>
                <div class="text-large font-weight-700 text-dark-brown padding-seven">
                    <h3 class="font-weight-600">{{subasta.establecimiento.nombre}}</h3>
                    <br>
                    <h3 class="font-weight-600">{{subasta.establecimiento.localidad}}</h3>
                    <ul class="list-detail">
                        <li>
                            <h4><strong>Categoría:</strong><br> {{subasta.categoria}}</h4>
                        </li>
                        <li>
                            <h4><strong>Cantidad:</strong><br> {{subasta.cantidad}}</h4>
                        </li>
                        <li>
                            <ng-container [ngSwitch]="subasta.marca">
                                <h4 *ngSwitchCase="'0'"><strong>Marca:</strong><br> Marca líquida</h4>
                                <h4 *ngSwitchCase="'1'"><strong>Marca:</strong><br> Compra</h4>
                                <h4 *ngSwitchCase="'2'"><strong>Marca:</strong><br> Marca líquida / Compra</h4>
                            </ng-container>
                        </li>
                        <li>
                            <h4><strong>Peso:</strong><br> {{subasta.peso}} kg.</h4>
                        </li>
                    </ul>
                </div>
                <!-- end  title -->
                <ng-template #template>
                    <div class="modal-header">
                        <h4 class="modal-title pull-left">Elija el tipo de notificaciones que desea recibir</h4>
                        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form [formGroup]="notificacionesForm" class="form-signin" (ngSubmit)="onSubmit()">
                            <input type="checkbox" name="notificar_sms" style="width:12px; height:12px;"
                                formControlName="notificar_sms"> Deseo Recibir Notificaciones via SMS <br>
                            <input type="text" name="celular" data-email="required" id="celular"
                                placeholder="* Nro de celular" class="medium-input border-radius-8"
                                formControlName="celular">
                            <input type="checkbox" name="notificar_email" style="width:12px; height:12px;"
                                formControlName="notificar_email"> Deseo Recibir Notificaciones via Email <br>
                            <input type="checkbox" name="notificar_dispositivo" style="width:12px; height:12px;"
                                formControlName="notificar_dispositivo"> Deseo Recibir Notificaciones en dispositivo
                            <br><br>
                            <div style="display: flex">
                                <button class="default-submit btn-small btn-circle btn bg-dark-brown text-white"
                                    type="submit">GUARDAR <i class="glyphicon glyphicon-ok-circle"></i></button>
                                <div *ngIf="loteSeguido.id">
                                    <span>&nbsp;</span>
                                    <a class="btn btn-small propClone btn-circle bg-dark-brown text-white font-weight-500"
                                        (click)="deleteLoteSeguido()"><span class="" id="">DEJAR DE SEGUIR <i
                                                class="glyphicon glyphicon-remove-circle"></i></span>
                                    </a>
                                </div>
                            </div>
                        </form>
                    </div>
                </ng-template>
            </div>
            <div class="col-md-8 margin-five-bottom">
                <div class="margin-two-bottom">
                    <tabset [justified]="true">
                        <tab heading="Fotos" id="tab1">
                            <div class="row" *ngIf="subasta.imagenes">
                                <owl-carousel #owlElement [options]="{items: 1, 
                                    dots: true, 
                                    navigation: false,
                                    responsiveClass: true, 
                                    itemsDesktop: [1200, 1], 
                                    itemsTablet: [800, 1], 
                                    itemsMobile: [700, 1]}" [items]="subasta.imagenes" [carouselClasses]="['owl-carousel', 
                                'owl-theme', 
                                'owl-light-pagination', 
                                'white-pagination', 
                                'testimonial-style3']">
                                    <div class="item" *ngFor="let imagen of subasta.imagenes">
                                        <img [src]="imagen.url" data-img-size="(W)800px X (H)650px" alt="">
                                    </div>
                                </owl-carousel>
                            </div>
                        </tab>
                        <tab heading="Video">
                            <!-- image -->
                            <div *ngIf="urlYoutube">
                                <div class="embed-responsive embed-responsive-16by9">
                                    <iframe class="embed-responsive-item" [src]="urlYoutube" frameborder="0"
                                        allowfullscreen=""></iframe>
                                </div>
                            </div>
                            <!-- end image -->
                        </tab>
                    </tabset>
                </div>
                <a class="btn btn-small propClone btn-circle bg-dark-brown text-white font-weight-500"
                    (click)="openModal(template)"><span class="" id="">SEGUIR <i class="far fa-bell"></i></span></a>
                <span> <i class="far fa-user"></i></span>
                <span> {{cantidadUsuariosLote}} usuarios siguiendo este lote</span>
            </div>
        </div>
    </div>
</section>
<section *ngIf="subasta && subasta.activo" class="bg-light-deep-yellow  border-none" id="">
    <div class="container-fluid">
        <div class="margin-four text-center text-medium text-red">
            <h2 *ngIf="ultimoMontoPuja == 0 && subasta.subasta" class="title-extra-large-2 width-100 text-dark-gray">
                Precio base: <strong> {{ separadorMiles(subasta.precioBase | currency : 'Gs.':'symbol':'3.0-0' )}}
                </strong></h2><br>
            <h2 *ngIf="ultimoMontoPuja > 0 && enPeriodoPuja" class="title-extra-large-2 width-100 text-dark-gray">
                {{labelUltimaPuja}}: <strong> {{ separadorMiles(ultimoMontoPuja | currency : 'Gs.':'symbol':'3.0-0') }}
                    <i class="fas fa-check text-deep-green"></i></strong></h2><br>
            <div
                *ngIf="!(subasta.compraDirecta) && !((enPeriodoPuja && subasta.subasta) || (enPeriodoCompraDirecta && subasta.compraDirecta)) && !vendido && !enPeriodoAleatorio && !finalizado">
                <strong class="title-medium text-deep-green"><i class="fas fa-clock "></i>Subasta inicia en <countdown
                        (reached)="callback($event)" [text]="text" units="Days | Hours | Minutes | Seconds"
                        end="{{ subasta.fechaInicioPuja }}"></countdown>
                </strong>
            </div>
            <div
                *ngIf="((enPeriodoPuja && subasta.subasta))  && !vendido && !enPeriodoAleatorio && !finalizado">
                <strong class="title-medium"><i class="fas fa-clock "></i> Subasta finaliza en <countdown
                        (reached)="callback($event)" [text]="text" units="Days | Hours | Minutes | Seconds"
                        end="{{ subasta.fechaFinPuja }}"></countdown></strong>
            </div>
            <div *ngIf="subasta.subasta && enPeriodoAleatorio">
                <strong class="title-medium"><img class="padding-one-half" src="assets/images/reloj.gif"> Estamos en el
                    periodo aleatorio </strong>
            </div>
            <div *ngIf="subasta.subasta && finalizado">
                <strong class="title-medium"><i class="fas fa-clock "></i> La subasta ha finalizado </strong>
            </div>
        </div>
        <div class="btn-dual text-center margin-five">
            <a *ngIf="ultimoMontoPuja == 0 && enPeriodoPuja"
                class="btn btn-large propClone btn-circle bg-dark-gray text-white margin-one" href="javascript:void(0)"
                (click)="pujar()"><span id="">¿ARRANCAMOS?<br><span class="title-medium">{{
                        separadorMiles (subasta.precioBase | currency : 'Gs.':'symbol':'3.0-0') }}</span></span></a>
            <a *ngIf="ultimoMontoPuja > 0 && enPeriodoPuja" [ngClass]="{btn:true, 'btn-large':true, propClone:true, 'btn-circle':true, 'text-white':true, 'margin-one':true,
                    'bg-deep-green': ultimoPujador, 'bg-yellow': !ultimoPujador}" href="javascript:void(0)"><span id=""
                    (click)="pujar()">¡PÓNGALE UNA PUJA!<br><span class="title-medium">{{
                        separadorMiles(montoPuja | currency : 'Gs. ':'symbol':'3.0-0') }}</span></span></a>
            <a *ngIf="vendido" class="btn desactivado btn-large propClone btn-circle bg-deep-red text-white margin-one"
                href="javascript:void(0)"><span id="">VENDIDO <span
                        class="fas fa-gavel rotate title-medium "></span><br><span class="title-medium"> {{ separadorMiles(precioVentaFinal | currency : 'Gs.':'symbol':'3.0-0')
                        }} </span></span></a>
            <div *ngIf="subasta.compraDirecta && !subasta.vendido">
                <a class="btn btn-large propClone btn-circle bg-dark-gray text-white margin-one"
                    href="javascript:void(0)" (click)="compraDirecta()"><span id="">COMPRA DIRECTA<br><span
                            class="title-medium">{{
                            separadorMiles(subasta.precioCompraDirecta | currency : 'Gs.':'symbol':'3.0-0') }}</span></span></a>
            </div>
        </div>
        <div *hasPermission="'ROLE_ADMIN'" class="container">
            <div class="row">
                <div *ngIf="ganador">
                    <h4>Comprador: {{ ganador.nombre }} {{ ganador.apellido }} ({{ ganador.username }})</h4>
                    <h4>Monto: {{ separadorMiles(ganador.monto | currency : 'Gs.':'symbol':'3.0-0')}} </h4>
                    <ng-container [ngSwitch]="subasta.tipoVenta">
                        <h4 *ngSwitchCase="'1'">Tipo venta: Compra Directa</h4>
                        <h4 *ngSwitchCase="'2'">Tipo venta: Puja</h4>
                    </ng-container>
                </div>
                <div class="col-md-12 text-large bg-white margin-five-bottom">
                    <table class="table precios">
                        <thead>
                            <tr>
                                <th scope="col">Fecha hora</th>
                                <th scope="col">Pujador</th>
                                <th scope="col">Monto</th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let puja of pujas">
                            <tr>
                                <td data-label="Fecha hora: "> {{ puja.fechaHora | date:'dd/MM/yyyy h:mm:ss' }} </td>
                                <td data-label="Pujador: ">{{ puja.nombre }} {{ puja.apellido }} ({{ puja.username }})
                                </td>
                                <td data-label="Monto: ">{{ separadorMiles(puja.monto | currency :
                                    'Gs.':'symbol':'3.0-0')}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div *hasPermission="'ROLE_ADMIN'" class="container">
            <div class="row" *ngIf="seguidoresLote">
                <div class="col-md-12 text-large bg-white margin-five-bottom">
                    <table class="table precios">
                        <thead>
                            <tr>
                                <th scope="col">Usuarios suscriptos</th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let usuario of seguidoresLote">
                            <tr>
                                <td data-label="Usuario">{{usuario.usuarios.nombre}} {{usuario.usuarios.apellido}}
                                    ({{usuario.usuarios.username}})</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>
<section *ngIf="subasta && subasta.activo" class="bg-light-deep-yellow  border-none" id="">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-lg-offset-2">
                <!-- section title -->
                <!-- end section title -->
                <div class="row bg-white margin-two-bottom">
                    <table class="table margin-two-bottom text-medium">
                        <tbody>
                            <tr>
                                <th>ESTABLECIMIENTO</th>
                                <td>{{subasta.establecimiento.nombre}}</td>
                            </tr>
                            <tr>
                                <th>CATEGORÍA</th>
                                <td>{{subasta.categoria}}</td>
                            </tr>
                            <tr>
                                <th>CANTIDAD</th>
                                <td>{{subasta.cantidad}}</td>
                            </tr>
                            <tr>
                                <th>PESO (kg)</th>
                                <td>{{subasta.peso}}</td>
                            </tr>
                            <tr>
                                <th>PESO MÁXIMO (kg)</th>
                                <td>{{subasta.pesoMaximo}}</td>
                            </tr>
                            <tr>
                                <th>PESO MÍNIMO (kg)</th>
                                <td>{{subasta.pesoMinimo}}</td>
                            </tr>
                            <tr>
                                <th>% DE PESAJE</th>
                                <td>{{subasta.porcentajePesaje}}%</td>
                            </tr>
                            <tr>
                                <th>HORA DE PESAJE</th>
                                <td>{{subasta.horaPesada | date:'H:mm'}}</td>
                            </tr>
                            <tr>
                                <th>HORA DE ENCIERRO</th>
                                <td>{{subasta.horasEncierro}} Horas</td>
                            </tr>
                            <tr>
                                <th>MARCA</th>
                                <ng-container [ngSwitch]="subasta.marca">
                                    <td *ngSwitchCase="'0'">Marca líquida</td>
                                    <td *ngSwitchCase="'1'">Compra</td>
                                    <td *ngSwitchCase="'2'">Marca líquida / Compra</td>
                                </ng-container>
                            </tr>
                            <tr>
                                <th>RAZA</th>
                                <td>{{subasta.raza}}</td>
                            </tr>
                            <tr>
                                <th>EDAD</th>
                                <td>{{subasta.edad}}</td>
                            </tr>
                            <tr>
                                <th>CALIDAD</th>
                                <td>{{subasta.calidad}}</td>
                            </tr>
                            <tr>
                                <th>ESTADO</th>
                                <td>{{subasta.estado}}</td>
                            </tr>
                            <tr>
                                <th>ESTADO REPRODUCTIVO</th>
                                <td>{{subasta.estadoReproductivo}}</td>
                            </tr>
                            <tr>
                                <th>NUTRICIÓN</th>
                                <td>{{subasta.nutricion}}</td>
                            </tr>
                            <tr>
                                <th>SANITACIÓN</th>
                                <td>{{subasta.sanitacion}}</td>
                            </tr>
                            <tr>
                                <th>LIBERAC. VACUNA AFTOSA</th>
                                <td>{{subasta.libercVacAftosa}}</td>
                            </tr>
                            <tr>
                                <th>IDENTIFICACIÓN</th>
                                <td>{{subasta.identificacion}}</td>
                            </tr>
                            <tr>
                                <th>ACCCESO</th>
                                <td>{{subasta.establecimiento.accesos}}</td>
                            </tr>
                            <tr>
                                <th>DISTANCIA</th>
                                <td>{{subasta.establecimiento.distancia}}</td>
                            </tr>
                            <tr>
                                <th>OBSERVACIONES</th>
                                <td>{{subasta.observaciones}} </td>
                            </tr>
                            <tr>
                                <th>CERTIFICADOR</th>
                                <td>{{subasta.certificador}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div *ngIf="subasta.latitud" class="col-md-12 margin-five-bottom" id="mapa-ubicacion">
                <agm-map [latitude]="subasta.latitud" [longitude]="subasta.longitud">
                    <agm-marker [latitude]="subasta.latitud" [longitude]="subasta.longitud"></agm-marker>
                </agm-map>
            </div>
            <div *ngIf="urlGoogleMaps" class="col-lg-12 btn-dual text-center margin-five">
                <a [href]="urlGoogleMaps" class="btn btn-large propClone btn-circle bg-dark-brown text-white margin-one"
                    target="_blank"><span id="">Ver en Google Maps</span></a>
            </div>
        </div>
        <div class="col-lg-12 btn-dual text-center margin-five">
            <a class="btn btn-large propClone btn-circle bg-dark-brown text-white margin-one" routerLink="/subastas"
                routerLinkActive="active"><span id="">VOLVER</span></a>
            <a *ngIf="anterior" class="btn btn-large propClone btn-circle bg-dark-brown text-white margin-one"
                [routerLink]="['/subastas', anterior.identificador]" routerLinkActive="active"><span
                    id="">ANTERIOR</span></a>
            <a *ngIf="siguiente" class="btn btn-large propClone btn-circle bg-dark-brown text-white margin-one"
                [routerLink]="['/subastas', siguiente.identificador]" routerLinkActive="active"><span
                    id="">SIGUIENTE</span></a>
        </div>
    </div>
</section>
<section class="padding-50px-tb bg-light-deep-yellow  xs-padding-60px-tb feature-style-31 border-none" id="">
    <div class="separator-line1 width-80 bg-dark-brown center-col  margin-five-bottom sm-margin-ten-bottom"></div>
    <div class="container">
        <div class="row">
            <!-- feature box -->
            <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-fifteen-bottom">
                <div class=" display-table width-100">
                    <a routerLink="/como-funciona" routerLinkActive="active">
                        <div class="text-dark-brown icon-style margin-seven-right display-table-cell-vertical-middle">
                            <span class="fas fa-info-circle title-extra-large-2 "></span></div>
                        <div class="display-table-cell-vertical-middle ">
                            <span class="text-medium text-medium-gray ">Información</span>
                            <h3 class="text-large alt-font text-dark-gray ">Como funciona</h3>
                        </div>
                    </a>
                </div>
            </div>
            <!-- end feature box -->
            <!-- feature box -->
            <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-fifteen-bottom">
                <div class=" display-table width-100">
                    <a routerLink="/condiciones-subasta" routerLinkActive="active">
                        <div class="text-dark-brown icon-style margin-seven-right display-table-cell-vertical-middle">
                            <span class="fas fa-gavel title-extra-large-2 "></span></div>
                        <div class="display-table-cell-vertical-middle ">
                            <span class="text-medium text-medium-gray ">Participar de subastas</span>
                            <h3 class="text-large alt-font text-dark-gray ">Condiciones</h3>
                        </div>
                    </a>
                </div>
            </div>
            <!-- end feature box -->
            <!-- feature box -->
            <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-fifteen-bottom">
                <div class=" display-table width-100">
                    <a routerLink="/login" routerLinkActive="active">
                        <div class="text-dark-brown icon-style margin-seven-right display-table-cell-vertical-middle">
                            <span class="fas fa-address-card title-extra-large-2 "></span></div>
                        <div class="display-table-cell-vertical-middle ">
                            <span class="text-medium text-medium-gray ">Únase hoy mismo</span>
                            <h3 class="text-large alt-font text-dark-gray ">Registro</h3>
                        </div>
                    </a>
                </div>
            </div>
            <!-- end feature box -->
            <!-- feature box -->
            <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-fifteen-bottom">
                <div class=" display-table width-100">
                    <a routerLink="/login" routerLinkActive="active">
                        <div class="text-dark-brown icon-style margin-seven-right display-table-cell-vertical-middle">
                            <span class="fas fa-sign-in-alt title-extra-large-2 "></span></div>
                        <div class="display-table-cell-vertical-middle ">
                            <span class="text-medium text-medium-gray ">¿Ya está registrado?</span>
                            <h3 class="text-large alt-font text-dark-gray ">Ingresar</h3>
                        </div>
                    </a>
                </div>
            </div>
            <!-- end feature box -->
        </div>
    </div>
</section>
